<template>
    <div class="col-lg-12">
        <div class="card border-top-0">
            <div class="card-body personal-info">
                <form @submit.prevent="submitForm">
                    <div class="mb-4 d-flex align-items-center justify-content-between">
                        <h5 class="fw-bold mb-0 me-4">
                            <span class="d-block mb-2">Kullanıcı Kartı Düzenle:</span>
                            <span class="fs-12 fw-normal text-muted text-truncate-1-line">Kullanıcı kartlarını
                                buradan düzenleyebilirsiniz.</span>
                        </h5>
                        <div class="d-flex gap-2">
                            <button type="submit" class="btn btn-lg btn-light-brand bg-green text-white">Kaydet</button>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Kullanıcı Adı: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="user.username"
                                    placeholder="Tedarikçi Adı">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">İsmi: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="user.first_name"
                                    placeholder="Kullanıcı İsmi">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Soyismi: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="user.last_name" placeholder="Soyismi">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">E-Posta: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="user.email"
                                    placeholder="E-Posta Adresi">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Aktif: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="form-check form-switch form-switch-lg">
                                <input class="form-check-input c-pointer" type="checkbox" checked="true"
                                    v-model="user.is_active">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-lg-2">
                            <label class="fw-semibold">Super Kullanıcı: </label>
                        </div>
                        <div class="col-lg-10">
                            <div class="form-check form-switch form-switch-lg">
                                <input class="form-check-input c-pointer" type="checkbox" checked="true"
                                    v-model="user.is_superuser">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
export default {
    name: 'EditUser',
    data() {
        return {
            user: {},
        }
    },
    async mounted() {
        const userId = this.$route.params.id;
        console.log(userId);
        if (userId) {
            await this.fetchSupplier(userId);
        }
    },
    methods: {
        async fetchSupplier(id) {
            try {
                const response = await this.$axios.get(`user/${id}/`);
                this.user = response.data;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        async submitForm() {
            console.log('kayıttan önce user:', this.user);
            try {
                const response = await this.$axios.patch(`user/${this.user.id}/`, this.user);
                Swal.fire('Başarılı', 'Kullanıcı başarıyla güncellendi.', 'success');
                console.log(response);
                this.$router.push({ name: 'Users', params: { page: 1 } });

            } catch (error) {
                Swal.fire('Hata', error, 'error');
                console.log(error);
            }
        }
    }
}
</script>